var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.isAnchor)?_c('button',{staticClass:"kraken-button",on:{"click":_vm.navigate}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e(),(_vm.isAnchor)?_c('a',{staticClass:"kraken-button",attrs:{"href":_vm.buttonLink}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }